import React, {Component} from 'react'
import {FastLayer, Image} from 'react-konva';
import './stage.css';

/** @class AnimationLayer
 * An AnimationLayer is a div that cycles through
 * multiple background-images
 */
export default class AnimationLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      frame: 0,
      frames: []
    };
    this.tick = this.tick.bind(this);
    this.loadFrames = this.loadFrames.bind(this);
  }
  /** @method componentDidMount
    *
    */
  componentDidMount() {
    if(this.props.frames) this.loadFrames(this.props.frames);
  }
  /** @method componentWillUnmount
    * Clears the interval timer.
    */
  componentWillUnmount() {
    window.clearInterval(this.interval);
  }
  /** @method loadFrames
    * Uses promises to load all frames before triggering the
    * animation with an interval.
    */
  loadFrames(frames) {
    Promise.all(Object.values(frames).map(frame => {
      return new Promise((resolve, reject) => {
        let image = new window.Image();
        image.onload = () => {
          resolve(image);
        }
        image.onerror = (err) => {
          reject(err);
        }
        image.src = frame.image;
      });
    })).then(images => {
      return this.setState({
        loading: false,
        frames: images
      });
    }).then( () => {
      window.clearInterval(this.interval);
      this.interval = window.setInterval(this.tick, this.props.speed);
    });
  }
  /** @method tick
    * Advances the animation by a frame.
    */
  tick() {
    var frame = (this.state.frame + 1) % this.state.frames.length;
    this.setState({frame: frame});
  }
  /** @function
   * Renders the animation (if loaded).
   */
  render() {
    if(this.state.loading) return null;
    return (
      <FastLayer>
        <Image
          image={this.state.frames[this.state.frame]}
          x={this.props.x}
          y={this.props.y}
          transformsEnabled="position"
          />
      </FastLayer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-preview/stage/animation-layer.js